import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { PopoverBase } from '../PopoverBase';
import { PlainTooltipContent } from '../PlainTooltipContent';
import { isFunction } from '../../helpers/isFunction';
export const PlainTooltip = forwardRef(function PlainTooltip(props, forwardedRef) {
    const { children, ...other } = props;
    const renderContent = ({ renderCursor, forwardedProps }) => (_jsx(PlainTooltipContent, { ...forwardedProps, ref: forwardedRef, renderCursor: renderCursor }));
    return (_jsx(PopoverBase, { ...other, role: 'tooltip', contentRenderer: renderContent, cursor: 'arrow', forwardProps: true, openEvents: { hover: true, focus: true }, children: (renderProps) => (_jsx("span", { style: { display: 'inline-flex' }, ...renderProps.getProps(), ref: renderProps.setRef, children: isFunction(children) ? children(renderProps) : children })) }));
});
